export default "/img/PG.fc164e927589e3802b054fd32c8b95ac.png";